import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "app-button",
  templateUrl: "./button.component.html",
  styleUrls: ["./button.component.scss"],
})
export class ButtonComponent implements OnInit {
  @Input() public routerLinkDelagate: string;
  @Input() public href: string;
  @Input() public text: string;
  @Input() public blackOnMobile: false;

  constructor() {}

  ngOnInit() {}
}
